import { parse } from "date-fns"

/* =====================
   Regex (top-level)
===================== */
const DAY_FIRST_DIGIT_REGEX = /^[0-3]$/
const DAY_SECOND_DIGIT_30_31_REGEX = /^[0-1]$/
const DAY_SECOND_DIGIT_01_29_REGEX = /^[1-9]$/
const DAY_SECOND_DIGIT_ANY_REGEX = /^[0-9]$/

const MONTH_FIRST_DIGIT_REGEX = /^[0-1]$/
const MONTH_SECOND_DIGIT_10_12_REGEX = /^[0-2]$/
const MONTH_SECOND_DIGIT_01_09_REGEX = /^[1-9]$/

/* =====================
   Validation
===================== */
export function isValidDateInput(value) {
  if (value.length > 10) {
    return false
  }

  const lastChar = value.at(-1)
  if (Number.isNaN(Number(lastChar)) && lastChar !== "/") {
    return false
  }

  return isValidDateByPosition(value)
}

function isValidDateByPosition(value) {
  const length = value.length

  if (length === 1) {
    return DAY_FIRST_DIGIT_REGEX.test(value[0])
  }

  if (length === 2) {
    const first = value[0]
    const second = value[1]

    if (first === "3") {
      return DAY_SECOND_DIGIT_30_31_REGEX.test(second)
    }
    if (first === "0") {
      return DAY_SECOND_DIGIT_01_29_REGEX.test(second)
    }
    return DAY_SECOND_DIGIT_ANY_REGEX.test(second)
  }

  if (length === 4) {
    return MONTH_FIRST_DIGIT_REGEX.test(value[3])
  }

  if (length === 5) {
    return value[3] === "1"
      ? MONTH_SECOND_DIGIT_10_12_REGEX.test(value[4])
      : MONTH_SECOND_DIGIT_01_09_REGEX.test(value[4])
  }

  return true
}

/* =====================
   Mask
===================== */
export function applyDateMask(value) {
  if (value.length === 2 || value.length === 5) {
    return `${value}/`
  }
  return value
}

/* =====================
   Date comparisons
===================== */
export function isAfterToday(value) {
  return parse(value, "dd/MM/yyyy", new Date()) > new Date()
}

export function isBeforeToday(value) {
  return parse(value, "dd/MM/yyyy", new Date()) < new Date()
}
